const blockingSearchResult = (state = null, action) => {
  if (action.type === "SET_BLOCKING_SEARCH_RESULT") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_BLOCKING_SEARCH_RESULT": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default blockingSearchResult;
